"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonalPropertyAssetType = void 0;
var PersonalPropertyAssetType;
(function (PersonalPropertyAssetType) {
    PersonalPropertyAssetType["JEWELRY_ELECTRONICS_AND_ANTIQUES"] = "JEWELRY_ELECTRONICS_AND_ANTIQUES";
})(PersonalPropertyAssetType || (exports.PersonalPropertyAssetType = PersonalPropertyAssetType = {}));
